import React from 'react';
import { SUPPORT_EMAIL } from '../../config';
import { Input } from '../../flayr-components/Input/Input';
import { Modal } from '../../flayr-components/Modal/Modal';
import { Select } from '../../flayr-components/Select/Select';
import { ShowIf } from '../../flayr-components/ShowIf/ShowIf';
import useStateWithInputEventHandler from '../../hooks/useStateWithInputEventHandler';
import CheckCircle from '../../lib/CheckCircle/CheckCircle';
import { postEmail, sendEmail } from '../../utils';

interface IContactModalProps {
  appointmentId?: string;
  open?: boolean;
  requesterInfo?: any;
  onClose?: (e?: any) => void;
}

const ContactModal: React.FC<React.PropsWithChildren<React.PropsWithChildren<IContactModalProps>>> = ({
  appointmentId,
  open,
  onClose,
  requesterInfo = {},
}) => {
  const [input, handleChange] = useStateWithInputEventHandler({
    subject: '',
    message: '',
  });
  const [emailSent, setEmailSent] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  const fromEmail = requesterInfo.email || SUPPORT_EMAIL;
  const toEmail = SUPPORT_EMAIL;

  async function handleSend() {
    setLoading(true);
    const body = await postEmail(
      {
        emails: [toEmail],
        body: `
        <pre>${input.message}</pre>
        ${
          (!requesterInfo.email &&
            `
          <p>Customer info:</p>
  
          <p>${JSON.stringify(requesterInfo)}</p>
          `) ||
          ''
        }
      `,
        subject: `appointment: ${appointmentId} -  ${input.subject}`,
      },
      {
        email: fromEmail,
        name: requesterInfo.name,
      }
    );

    setLoading(false);
    setEmailSent(true);
  }

  React.useEffect(() => {
    return () => {
      setEmailSent(false);
    };
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      footer
      okLabel="Send"
      title="Contact Flayr"
      onOk={handleSend}
      okBtnProps={{ loading, hidden: emailSent }}
    >
      <ShowIf
        condition={!emailSent}
        elseTemplate={
          <div className="text-center">
            <div className="flex items-center justify-center">
              <CheckCircle className="text-green-500 text-7xl" />
            </div>
            <p className="mt-5 leading-snug">
              Your message has been sent. We will get back to you soon. Thanks.
            </p>
          </div>
        }
      >
        <Select
          label="Subject"
          labelClassName="block text-sm"
          name="subject"
          value={input.subject}
          onChange={handleChange}
          placeholder="Select a subject"
          size="lg"
          options={['Contact', 'Other']}
        />
        <Input
          type="textarea"
          label="Message"
          name="message"
          size="lg"
          labelClassName="block text-sm"
          placeholder="Enter your message"
          value={input.message}
          onChange={handleChange}
        />
      </ShowIf>
    </Modal>
  );
};
export default ContactModal;
